import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import MobileStepper from '@mui/material/MobileStepper';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

const CARD_WIDTH = 360;

const TourCard = ({
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  ...props
}) => {
  const {t} = useTranslation();

  const nextButtonText = props.isLastStep
    ? step.finishLabel || t('tourDialog.buttonFinish')
    : t('tourDialog.buttonNext');

  const NextButton = () => (
    <Button size="small" data-qe="tour-card-next-button" {...primaryProps}>
      {nextButtonText}
      {!props.isLastStep && <KeyboardArrowRight />}
    </Button>
  );

  return (
    <Card
      raised
      sx={{width: CARD_WIDTH}}
      data-qe={`tour-card-${step.id}`}
      {...tooltipProps}
    >
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        px={2}
        paddingTop={1}
        marginBottom={0.5}
        width="100%"
      >
        <Typography
          variant="subtitle1"
          component="h2"
          display="block"
          data-qe="tour-card-title"
        >
          {step.title || ''}
        </Typography>
        <IconButton
          size="small"
          sx={{
            position: 'absolute',
            right: 4,
            top: 4,
            zIndex: 1,
          }}
          data-qe="tour-card-close-button"
          {...closeProps}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <CardContent sx={{paddingTop: 1}}>
        <Typography variant="body2" data-qe="tour-card-content">
          {step.content}
        </Typography>
      </CardContent>
      {props.size > 1 ? (
        <MobileStepper
          position="static"
          steps={props.size}
          activeStep={index}
          nextButton={<NextButton />}
          backButton={
            <Button
              size="small"
              data-qe="tour-card-back-button"
              disabled={index === 0}
              {...backProps}
            >
              <KeyboardArrowLeft />
              {t('tourDialog.buttonBack')}
            </Button>
          }
          data-qe="tour-card-stepper"
        />
      ) : (
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          px={1}
          paddingBottom={1}
        >
          <NextButton />
        </Box>
      )}
    </Card>
  );
};

TourCard.propTypes = {
  continuous: PropTypes.bool,
  index: PropTypes.number,
  step: PropTypes.object,
  backProps: PropTypes.object,
  closeProps: PropTypes.object,
  primaryProps: PropTypes.object,
  tooltipProps: PropTypes.object,
  isLastStep: PropTypes.bool,
  size: PropTypes.number,
  finishLabel: PropTypes.string,
};

export default TourCard;
